import type { ReactNode } from "react";

import { GradientBackground } from "@/shared/ui/gradient-background";
import {
  createOrganizationSchema,
  createWebSiteSchema,
} from "@/utils/structured-data";
import { Footer } from "@/web/landing/components/footer";
import { Header } from "@/web/landing/components/header";

type Props = {
  children: ReactNode;
};

export function WebLayout({ children }: Props) {
  const organizationSchema = createOrganizationSchema();
  const websiteSchema = createWebSiteSchema();

  return (
    <>
      {/* Global Structured Data */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(
            organizationSchema,
            null,
            0
          ),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(websiteSchema, null, 0),
        }}
      />

      <div className="relative flex min-h-screen flex-col overflow-hidden bg-background">
        <GradientBackground variant="default" />

        <Header />
        <main className="relative z-10 flex-1">
          {children}
        </main>
        <Footer />
      </div>
    </>
  );
}
